module.exports = __webpack_public_path__ + "img/hatch-thankyou-step1.4f5e3725.svg";